import {IOrder} from "../model/types";

const API_BASE = (typeof window !== 'undefined' && (window as any).REACT_APP_API_URL) || (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) || '/api';
const URL = `${API_BASE}/CallRequest/new`;
const headers = {
    'Content-Type': 'application/json',
}

export const ordersAPI = {
    add: (order: IOrder) => {
        return fetch(URL, {
            method: 'POST',
            headers,
            body: JSON.stringify(order),
        })
            .then((response) => response);
}
}
